jQuery(function($) {

  // Approximate pixel 'duration' of each stage of HIW
  var keyframeDuration = 750;

  // skrollr init
  var s = skrollr.init({
    forceHeight: false
  });

  // Disable skrollr on mobile
  if (s.isMobile() || $('body').hasClass('is-ie')) {
    s.destroy();
  }

  // Adjust key down/up
  $(document).keydown(function(e) {
      switch(e.which) {
        case 38: // up
        $('html,body').animate({
          scrollTop: $(window).scrollTop() - keyframeDuration
        }, 50);
        break;

        case 40: // down
        $('html,body').animate({
          scrollTop: $(window).scrollTop() + keyframeDuration
        }, 50);
        break;

        default:
        return;
      }
      e.preventDefault();
  });

  //Fix Orphans/Widows
  $('section h1 , section h2 , section p , .detail h1 , blockquote p ').widowFix({
    letterLimit: 9,
    linkFix: false
  });
});
